import React from "react";

interface PillProps {
  text: string;
  color: string;
  bgColor: string;
  borderColor: string;
  icon?: React.ReactNode;
  className?: string;
}

const Pill: React.FC<PillProps> = ({
  text,
  color,
  bgColor,
  borderColor,
  icon,
  className,
}) => {
  const pillStyle: React.CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
    padding: "3px 8px",
    borderRadius: "9999px",
    border: `1px solid ${borderColor}`,
    backgroundColor: bgColor,
    color: color,
    fontFamily: "Interstate",
    fontSize: "11.996px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "16px",
    whiteSpace: "nowrap",
  };

  return (
    <span style={pillStyle} className={className}>
      {icon && <span className="flex items-center">{icon}</span>}
      <span>{text}</span>
    </span>
  );
};

export default Pill;
